<template>
    <div class="d-flex justify-content-between mb-4 py-3">
        <div>
            <router-link class="back-route h3" ref="backBtn" @click="backHandler" :to="isFull ? '#':'/competitions'">
                <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                Edit Competition
            </router-link>
        </div>
        <div class="d-flex justify-content-center">
            <button @click.prevent="EditCompetition" class="styleBtnCss">Edit Competition</button>
            &nbsp;&nbsp;
<!--            <button @click.prevent="AssignUsers" class="styleBtnCss2">Save & Assign</button>-->
        </div>
    </div>

    <div id="createUserContainer" class="tabcontent1">
        <div class="row col-12">
            <div class="col-md-4">
                <label for="inputName" class="form-label">Name</label>
                <input type="text" @input="[changeHandler($event, errors, 'name'), setData($event,'name')]"
                       v-model="competition.name" autocomplete="off" class="custom-input form-control" id="inputName" placeholder="Name">
                <div class="err" v-if="errors['name'].length > 0">
                    <div v-for="msg in errors['name']" class="text-danger">{{msg}}</div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="template_id1" class="form-label">Template to Use</label>
                <select id="template_id1" class="form-select" v-model="competition.template_id">
                    <option value="null" disabled selected>Template to Use</option>
                    <option v-for="template in templates" :value="template.id">{{template.name}}</option>
                </select>
            </div>
            <div class="col-md-4">
                <label for="template_id2" class="form-label">Template to Use</label>
                <select id="template_id2" class="form-select" v-model="competition.participant_type">
                    <option value="null" disabled selected>Participant Type</option>
                    <option value="individual">Individual</option>
                    <option value="team">Team</option>
                </select>
            </div>
        </div>
    </div>

    <br>
    <br>

    <div id="createUserContainer2" class="tabcontent2">
        <div class="row col-12">
            <div class="col-md-6">
                <label for="inputName" class="form-label">Competition Time</label>
                <div class="d-flex cssRangDates">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" @click="showRangeDates" value="1" v-model="competition.date_type" :checked="competition.date_type === 1">
                        <label class="form-check-label" for="flexRadioDefault1">
                            Range of Dates
                        </label>
                    </div>
                    &nbsp;&nbsp;&nbsp;
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" @click="showSpecificDates" value="2" v-model="competition.date_type" :checked="competition.date_type === 2">
                        <label class="form-check-label" for="flexRadioDefault2">
                            Specific Date and Time
                        </label>
                    </div>
                </div>
            </div>

            <!-- specific dates -->
            <div v-if="isActivatedSpecific === true" class="col-md-12 pt-5 d-flex">
                <div class="col-md-4">
                    <h4>Select Date</h4>
                    <div>
                        <label>End Date</label>
                        <input type="date" autocomplete="off" class="form-control cssEndDate" v-model="competition.end_date" :min="minToday">
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="allCssTime">
                        <div class="firstCssTime">
                            <h4>Select Time</h4>
                            <label>Start Time</label>
                            <input type="time" autocomplete="off" class="form-control styleFirstTime" v-model="competition.start_time" @input="checkTimes1">
                        </div>
                        <div class="secondCssTime">
                            <label>End Time</label>
                            <input type="time" class="form-control styleSecondTime" autocomplete="off" v-model="competition.end_time" @input="checkTimes2">
                        </div>
                    </div>
                </div>
            </div>

            <!-- range dates -->
            <div v-if="isActivatedRange === true" class="col-md-12 pt-5 d-flex">
                <div class="col-md-9">
                    <h4>Select Date</h4>
                    <div class="allCssDate">
                        <div class="firstDateStyle1">
                            <label>Start Date</label>
                            <input type="date" autocomplete="off" class="form-control cssFirstDateOne" v-model="competition.start_date" @input="checkDates1" :min="minToday">
                        </div>
                        <div class="secondDateStyle2">
                            <label>End Date</label>
                            <input type="date" autocomplete="off" class="form-control cssSecondDateTwo" v-model="competition.end_date" @input="checkDates2" :min="minToday">
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <h4>Select Duration</h4>
                    <div class="cssDuration">
                        <label>Duration</label>
                        <input type="text" autocomplete="off" class="form-control styleFirstTime" v-model="competition.duration">
                    </div>
                </div>
            </div>

        </div>
    </div>

    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>

    <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import ConfirmationModal from "../../components/ConfirmationModal";
    import AlartModal from "../../components/AlartModal";
    import changeHandler from "../../../validation/userValidation";
    import {computed} from "vue";
    import competition from "../../../api-services/competition";
    import repository from "../../../api-services/repository";
    import moment from "moment";

    export default {
        name: 'edit-competition',
        components:{
            ConfirmationModal,
            AlartModal
        },
        data(){
            return{
                changeHandler,
                isActivatedRange:false,
                isActivatedSpecific:false,
                ImagePath:'',
                templates:[],
                minToday:'2022/01/01',
                firstTimeInDay:'00:00:00',
                lastTimeInDay:'23:59:59',
                competition: {
                    name:null,
                    type:1,
                    participant_type:null,
                    date_type:null,
                    start_date:null,
                    end_date:null,
                    duration:null
                },
                errors:{
                    name:[],
                    type:[],
                    participant_type:[],
                    date_type:[],
                    start_date:[],
                    end_date:[],
                    duration:[],
                    isError: false
                },
                showModal:false,
                message:null,
                errorMessages:[],
                responseErrorMessage:'',
                showErrorModal:false,
                isFull: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{
                    name: false,
                    user_email: false,
                    host:false
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
            }
        },

       async mounted(){
            await this.$store.dispatch('activeTap', 'competition');
            this.getCompetition();
            this.getTemplate();

           let today = new Date().toISOString().split('T')[0];
           this.minToday = today;
        },
        methods:{
            checkTimes1(e){
                if(e.target.value > this.competition.end_time){
                    this.competition.end_time = null;
                }
            },
            checkTimes2(e){
                if(e.target.value < this.competition.start_time){
                    this.competition.start_time = null;
                }
            },
            checkDates1(e){
                if(e.target.value > this.competition.end_date){
                    this.competition.end_date = null;
                }
            },
            checkDates2(e){
                if(e.target.value < this.competition.start_date){
                    this.competition.start_date = null;
                }
            },
            async getTemplate(){
                try{
                    const response = await repository.index('templates');
                    this.templates = response.data.data.data;

                }catch(e){
                    console.log(e);
                }
            },
            async getCompetition(){
                try{
                    const competition_id = this.$route.params.id;
                    const response = await competition.show(competition_id);

                    this.competition.name = response.data.data.name;
                    this.competition.template_id = response.data.data.template.id;
                    this.competition.date_type = response.data.data.date_type;
                    this.competition.participant_type = response.data.data.participant_type;
                    this.competition.start_date = response.data.data.start_date;
                    this.competition.end_date = response.data.data.end_date;
                    this.competition.start_time = response.data.data.start_time;
                    this.competition.end_time = response.data.data.end_time;
                    this.competition.duration = response.data.data.duration;

                    if(response.data.data.date_type === "1"){
                        this.isActivatedRange = true;
                        this.isActivatedSpecific = false;
                    }else{
                        this.isActivatedRange = false;
                        this.isActivatedSpecific = true;
                    }

                }catch(e){
                    console.log(e);
                }
            },
            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            setData(e, type) {
                let val = e.target.value;
                if (type === 'name') {
                    if (val !== '') {
                        this.isData.name = true;
                    } else {
                        this.isData.name = false;
                    }
                }

                if (type === 'user_email') {
                    if (val !== '') {
                        this.isData.user_email = true;
                    } else {
                        this.isData.user_email = false;
                    }
                }

                if (type === 'host') {
                    if (val !== '') {
                        this.isData.host = true;
                    } else {
                        this.isData.host = false;
                    }
                }
                if (this.isData.name || this.isData.user_email || this.isData.host) {
                    this.$store.dispatch('setDataFlag', true);
                    console.log('data ==>> ')
                } else {
                    this.$store.dispatch('setDataFlag', false);
                    console.log('no data ==>> ');
                }

            },
            async confirmModalHandler (event) {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if(event){
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/competitions');
                }
            },
            async EditCompetition(){
                try{
                    const competition_id = this.$route.params.id;
                    if(this.competition.name === null || this.competition.template_id === null || this.competition.end_date === null || this.competition.participant_type === null){
                        this.showModal = true;
                        this.ImagePath = 'close.png';
                        this.message = 'Please Fill Data Correctly';
                    }else{
                        if(this.competition.date_type === 1){
                            if(this.competition.start_date === null || this.competition.duration === null){
                                this.showModal = true;
                                this.ImagePath = 'close.png';
                                this.message = 'Please Fill Data Correctly';
                            }else if(this.competition.start_date === this.competition.end_date) {
                                this.showModal = true;
                                this.ImagePath = 'close.png';
                                this.message = 'Start Date Cannot Be Equal End Date';
                            }else {
                                let duration = moment.duration(moment(this.competition.end_date).diff(moment(this.competition.start_date)));
                                let minutesCheck = duration.asMinutes();

                                if (this.competition.duration > minutesCheck) {
                                    this.showModal = true;
                                    this.ImagePath = 'close.png';
                                    this.message = 'Check Duration Mintues between start date and end date';
                                } else {
                                    await competition.update(competition_id, {
                                        name: this.competition.name,
                                        type: this.competition.type,
                                        template_id: this.competition.template_id,
                                        date_type: this.competition.date_type,
                                        participant_type: this.competition.participant_type,
                                        start_date: this.competition.start_date,
                                        end_date: this.competition.end_date,
                                        start_time: this.firstTimeInDay,
                                        end_time: this.lastTimeInDay,
                                        duration: this.competition.duration
                                    });
                                    await this.$store.dispatch('setDataFlag', false);

                                    this.$router.push({path: '/complete-edit-competitions/' + competition_id});
                                }
                            }
                        }else{
                            if(this.competition.end_date === moment().format('YYYY-MM-DD')){
                                console.log(moment(this.competition.start_time , 'hh:mm A').format('hh:mm A') , moment().format('hh:mm A'));
                                if(moment(this.competition.start_time , 'hh:mm A').format('hh:mm A') < moment().format('hh:mm A')){
                                    this.showModal = true;
                                    this.ImagePath = 'close.png';
                                    this.message = 'Please Check Start Time Not Be Before Now';
                                }else{
                                    let startTime = moment(this.competition.end_date).format('YYYY-MM-DD') + 'T' + this.competition.start_time;
                                    let endTime = moment(this.competition.end_date).format('YYYY-MM-DD') + 'T' + this.competition.end_time;
                                    let diffD = moment.duration(moment(endTime).diff(moment(startTime))).as('minutes');
                                    console.log(diffD);

                                    this.competition.duration = diffD;

                                    const response = await competition.update({
                                        name:this.competition.name,
                                        type:this.competition.type,
                                        participant_type:this.competition.participant_type,
                                        template_id:this.competition.template_id,
                                        date_type:this.competition.date_type,
                                        start_date:this.minToday,
                                        end_date:this.competition.end_date,
                                        start_time:this.competition.start_time,
                                        end_time:this.competition.end_time,
                                        duration:this.competition.duration
                                    });
                                    await this.$store.dispatch('setDataFlag', false);

                                    this.$router.push({path: '/complete-edit-competitions/'+response.data.data.id});
                                }
                            }else{
                                const response = await competition.update({
                                    name:this.competition.name,
                                    type:this.competition.type,
                                    participant_type:this.competition.participant_type,
                                    template_id:this.competition.template_id,
                                    date_type:this.competition.date_type,
                                    start_date:this.minToday,
                                    end_date:this.competition.end_date,
                                    start_time:this.competition.start_time,
                                    end_time:this.competition.end_time,
                                    duration:this.competition.duration
                                });
                                await this.$store.dispatch('setDataFlag', false);

                                this.$router.push({path: '/complete-edit-competitions/'+response.data.data.id});
                            }
                        }
                    }
                }catch(e){
                    console.log(e);
                }
            },
            showRangeDates(){
                this.isActivatedRange = true;
                this.isActivatedSpecific = false;
                this.competition.start_time = null;
                this.competition.end_time = null;
                this.competition.end_date = null;
            },
            showSpecificDates(){
                this.isActivatedRange = false;
                this.isActivatedSpecific = true;
                this.competition.start_date = null;
                this.competition.duration = null;
                this.competition.end_date = null;
            }
        }
    }
</script>

<style scoped>
    ::-webkit-calendar-picker-indicator {
        filter: invert(100%);
    }

    .cssFirstDateOne{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .cssSecondDateTwo{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .allCssTime{
        display: flex;
        flex-wrap: wrap;
        justify-content: end;
        align-items: end;
        gap:50px;
    }

    .allCssDate{
        display: flex;
        flex-wrap: wrap;
        gap:50px;
    }

    .styleSecondTime{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .styleFirstTime{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .cssEndDate{
        background-color: #021A24;
        color: #fff;
        width:350px;
        padding: 10px;
    }
    .cssRangDates{
        border: 1px solid #04354a;
        padding: 10px;
        width:360px;
    }
    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: none !important;
        border: 2px solid #032a3a !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }

    .form-check-input:focus {
        box-shadow: 0 0 0 1px #e95626 !important;
    }
    #template_id1{
        background-color: #032A3A;
        color: #fff;
        padding: 10px;
    }
    #template_id2{
        background-color: #032A3A;
        color: #fff;
        padding: 10px;
    }
    .custom-input{
        background-color: #032A3A;
        color: #fff;
        padding: 10px;
    }
    .styleBtnCss2{
        width: 180px;
        background-color: transparent;
        color: #FFF;
        padding: 8px;
        border-radius: 6px;
        font-weight: bold;
        border: 2px solid #fff;
    }
    .styleBtnCss{
        width: 180px;
        background-color: #E95626;
        color: #FFF;
        padding: 8px;
        border-radius: 6px;
        font-weight: bold;
        border: none;
    }
    .tabcontent2{
        display: block;
        padding: 30px;
        height: 30vh;
        border-top: none;
        background-color: #032A3A;
        border-radius: 15px;
    }
    .tabcontent1{
        display: block;
        padding: 30px;
        height: 20vh;
        border-top: none;
        background-color: #032A3A;
        border-radius: 15px;
    }
</style>